import { createContext, useContext, useRef } from "react";

/** Interface */
export interface IModalContext {
	isOpen: boolean;
	onClose: () => void | Promise<void>;
	onSubmit?: () => void;
}

export interface IModalFooterRefContext {
	footerRef: React.RefObject<HTMLDivElement | null>;
}

/** Context */
export const ModalContext = createContext<IModalContext>({} as IModalContext);
export const ModalFooterRefContext = createContext<IModalFooterRefContext>(
	{} as IModalFooterRefContext,
);

/** Hooks */
export function useModalContext() {
	return useContext(ModalContext);
}

export function useModalFooterRefContext() {
	return useContext(ModalFooterRefContext);
}

export function useModalFooterRef() {
	const footerRef = useRef<HTMLDivElement>(null);

	return { footerRef };
}
